import AccessRequestsRoutes from "PFApp/routes/admin/access_requests_routes";
import AccountContactsRoutes from "PFApp/routes/admin/account_contacts_routes";
import AllowedDomainsRoutes from "PFApp/routes/admin/allowed_domains_routes";
import AuditLogRoutes from "PFApp/routes/admin/audit_log_routes";
import BookingConfigsRoutes from "PFApp/routes/admin/booking_config_routes";
import BrandingRoutes from "PFApp/routes/admin/branding_routes";
import ChangeRequestsRoutes from "PFApp/routes/admin/change_requests_routes";
import CollaboratorsConfigsRoutes from "PFApp/routes/admin/collaborators_configs_routes";
import CustomFieldsRoutes from "PFApp/routes/admin/custom_fields_routes";
import EmailTemplatesRoutes from "PFApp/routes/admin/email_templates_routes";
import InterestQuestionsRoutes from "PFApp/routes/admin/interest_questions_routes";
import PermissionsGroupRoutes from "PFApp/routes/admin/permissions_groups_routes";
import RssRoutes from "PFApp/routes/admin/rss_routes";
import SamlConfigsRoutes from "PFApp/routes/admin/saml_configs_routes";
import { SkillsManagementRoutes } from "PFApp/routes/admin/skills_management_routes";
import AdminUserRoutes from "PFApp/routes/admin/user_routes";
import NotFoundRoute from "PFApp/routes/not_found_route";
import {
  EnsureFeatureEnabled,
  EnsureIsAdmin,
  EnsureLoggedInAndRegistered,
  EnsureProfilePermission,
  WithLayout
} from "PFApp/routes/route_helpers";
import { admin } from "PFCore/base/page_layouts";
import { FeatureFlag, PermissionRule } from "PFTypes";
import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import { SkillsFrameworksRoutes } from "./admin/skills_frameworks_routes";

const AdminRoutes = () => {
  const { path } = useRouteMatch();

  return (
    <EnsureLoggedInAndRegistered>
      <EnsureIsAdmin>
        <WithLayout layout={{ sidebar: admin }}>
          <Switch>
            <Route exact path={path}>
              <Redirect to={`${path}/users`} />
            </Route>
            <Route path={`${path}/users`}>
              <AdminUserRoutes />
            </Route>
            <Route path={`${path}/change_requests`}>
              <ChangeRequestsRoutes />
            </Route>
            <Route path={`${path}/audit_logs`}>
              <AuditLogRoutes />
            </Route>
            <Route path={`${path}/allowed_domains`}>
              <AllowedDomainsRoutes />
            </Route>
            <Route path={`${path}/permissions_groups`}>
              <PermissionsGroupRoutes />
            </Route>
            <Route path={`${path}/custom_fields`}>
              <CustomFieldsRoutes />
            </Route>
            <Route path={`${path}/branding`}>
              <BrandingRoutes />
            </Route>
            <Route path={`${path}/rss`}>
              <RssRoutes />
            </Route>
            <Route path={`${path}/access_requests`}>
              <AccessRequestsRoutes />
            </Route>
            <Route path={`${path}/saml_configs`}>
              <SamlConfigsRoutes />
            </Route>
            <Route path={`${path}/account_contacts`}>
              <AccountContactsRoutes />
            </Route>
            <Route path={`${path}/skills_management`}>
              <SkillsManagementRoutes />
            </Route>
            <Route path={`${path}/email_templates`}>
              <EmailTemplatesRoutes />
            </Route>
            <Route path={`${path}/collaborators_configs`}>
              <CollaboratorsConfigsRoutes />
            </Route>
            <Route path={`${path}/interest_questions`}>
              <InterestQuestionsRoutes />
            </Route>
            <Route path={`${path}/booking`}>
              <EnsureFeatureEnabled feature={FeatureFlag.BookingModule}>
                <EnsureProfilePermission permittedTo={PermissionRule.BookingAdmin}>
                  <BookingConfigsRoutes />
                </EnsureProfilePermission>
              </EnsureFeatureEnabled>
            </Route>
            <Route path={`${path}/skills_frameworks`}>
              <EnsureFeatureEnabled feature={FeatureFlag.SkillsFramework}>
                <SkillsFrameworksRoutes />
              </EnsureFeatureEnabled>
            </Route>
            <Route path="*">
              <NotFoundRoute />
            </Route>
          </Switch>
        </WithLayout>
      </EnsureIsAdmin>
    </EnsureLoggedInAndRegistered>
  );
};

export default AdminRoutes;
